import {Box} from '@mui/material';
import {useTranslation} from "react-i18next";
import CustomChip from "../customChip/CustomChip";
import styles from './NoDataLabel.module.scss';

export default function NoDataLabel (){
    const {t} = useTranslation();

    return (
        <Box className={styles.container}>
            <CustomChip label={t("NODATA")} />
        </Box>
    )
}